import Config from './config';

export default class IpfeedApiClient {

  constructor() {
    this.ipfeedApi = Config.IPFEED_API_ENDPOINT;
  }

  // ipfeed API用 リクエストヘッダやその他設定
  getIpfeedOptions(param) {
    return {
      method  : 'POST',
      mode    : 'cors',
      body    : JSON.stringify(param),
      headers : {
        'Accept'      : 'application/json',
        'Content-Type': 'application/json'
      },
      referrerPolicy : 'no-referrer-when-downgrade'
    };
  }

  getFeed(param) {
    const ipfeedRequest = Promise.race([
      fetch(`${this.ipfeedApi}`, this.getIpfeedOptions(param)),
      new Promise(function (resolve, reject) {
        // タイムアウト設定
        setTimeout(() => resolve(), 5000)
      })
    ])

    return ipfeedRequest.then((response) => {
      if (!response.ok) {
        return;
      }
      return response.json();
    });
  }
}
